import { type UseQueryResult, useQuery } from 'react-query';
import { UserDefinedFieldsService } from '@wealthlane/api-services/wealthlane-customer-service';

const useGetUdfStatus = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const udfOptions = useQuery(
    ['getUdfOptions'],
    async () => {
      return await handleRequest(
        UserDefinedFieldsService.getApiCustomerApiAppUserDefinedFieldsUserDefinedStatus()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return udfOptions;
};

export default useGetUdfStatus;
